import Datetime from 'react-datetime';
import './style.css';
import { useState } from 'react';

export const JPDatePicker = ({ label = 'Date', style = {}, setter, val }) => {
  const [date, setDate] = useState('');

  return (
    <div style={style}>
      {label}
      <Datetime
        style={{ margin: 5, height: 35 }}
        closeOnSelect={true}
        dateFormat="D/MM/YYYY"
        timeFormat={false}
        value={date}
        onChange={(selectedDate) => {
          setDate(selectedDate);
          setter(selectedDate);
        }}
      />
    </div>
  );
};
